export const SCENE_EFFECT_DEFAULTS = {
    fog: { intensity: 0.45, speed: 1 },
    rain: { intensity: 0.55, speed: 1, particleSize: 1 },
    snow: { intensity: 0.8, speed: 0.6, particleSize: 1 },
    lightning: { intensity: 0.35, speed: 1 },
    particles: { intensity: 0.55, speed: 1, particleSize: 1.15, color: '#ffdc78' },
    vignette: { intensity: 0.45, speed: 1 },
};
export const SCENE_EFFECT_PARAM_DOCS = {
    fog: ['intensity (0-1)', 'speed'],
    rain: ['intensity (0-1)', 'speed', 'particleSize (px)'],
    snow: ['intensity (0-1)', 'speed', 'particleSize (px)'],
    lightning: ['intensity (0-1)', 'speed (flash frequency multiplier)'],
    particles: ['intensity (0-1)', 'speed', 'particleSize (px)', 'color (hex)'],
    vignette: ['intensity (0-1)'],
};
/** UI controls for each effect type (editor Scene Effects panel). */
export const SCENE_EFFECT_PARAM_UI = {
    fog: [
        { key: 'intensity', kind: 'number', min: 0, max: 1, step: 0.01 },
        { key: 'speed', kind: 'number', min: 0, max: 3, step: 0.05 },
    ],
    rain: [
        { key: 'intensity', kind: 'number', min: 0, max: 1, step: 0.01 },
        { key: 'speed', kind: 'number', min: 0, max: 3, step: 0.05 },
        { key: 'particleSize', kind: 'number', min: 0.1, max: 5, step: 0.05 },
    ],
    snow: [
        { key: 'intensity', kind: 'number', min: 0, max: 1, step: 0.01 },
        { key: 'speed', kind: 'number', min: 0, max: 3, step: 0.05 },
        { key: 'particleSize', kind: 'number', min: 0.1, max: 5, step: 0.05 },
    ],
    lightning: [
        { key: 'intensity', kind: 'number', min: 0, max: 1, step: 0.01 },
        { key: 'speed', kind: 'number', min: 0, max: 3, step: 0.05 },
    ],
    particles: [
        { key: 'intensity', kind: 'number', min: 0, max: 1, step: 0.01 },
        { key: 'speed', kind: 'number', min: 0, max: 3, step: 0.05 },
        { key: 'particleSize', kind: 'number', min: 0.1, max: 5, step: 0.05 },
        { key: 'color', kind: 'color' },
    ],
    vignette: [{ key: 'intensity', kind: 'number', min: 0, max: 1, step: 0.01 }],
};
export function isSceneEffectType(value) {
    return value in SCENE_EFFECT_DEFAULTS;
}
export function parseSceneEffectParams(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw))
        return {};
    const record = raw;
    const params = {};
    if (typeof record.intensity === 'number')
        params.intensity = record.intensity;
    if (typeof record.particleSize === 'number')
        params.particleSize = record.particleSize;
    if (typeof record.speed === 'number')
        params.speed = record.speed;
    if (typeof record.color === 'string')
        params.color = record.color;
    return params;
}
export function mergeEffectParams(effectType, properties) {
    return { ...SCENE_EFFECT_DEFAULTS[effectType], ...properties };
}
export function serializeEffectParams(params) {
    return JSON.stringify(params);
}
